import React from "react";

const FeedPage = () => {
  return <div>FeedPage</div>;
};

export default FeedPage;
